import { Spinner, Tag } from "@blueprintjs/core";
import * as React from "react";
import { useQuery } from "react-query";
import { useCommonHooks } from "../../hooks";

export interface ISessionAwaitingValidationCounterProps {}

export const SessionAwaitingValidationCounter: React.FunctionComponent<ISessionAwaitingValidationCounterProps> =
  (props) => {
    const { apis } = useCommonHooks();
    const { data, isFetching } = useQuery(
      "sessions-awaiting-presence",
      async () => {
        return apis.training.getSessionAwaitingPresences();
      },
      { cacheTime: 30 }
    );

    return (
      <Tag intent="danger" round>
        {isFetching ? <Spinner size={10} /> : data.value}
      </Tag>
    );
  };
